import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

const FAHRENHEIT_RANKINE_CONSTANT = 459.67;
const CELSIUS_FAHRENHEIT_CONSTANT = 32;

export const Fahrenheit: ConvertableUnit = {
  label: "F°",
  toStandardUnit: F => F,
  toThisUnit: F => F
};

export const Celsius: ConvertableUnit = {
  label: "C°",
  toStandardUnit: C => C * (9 / 5) + CELSIUS_FAHRENHEIT_CONSTANT,
  toThisUnit: F => (F - CELSIUS_FAHRENHEIT_CONSTANT) * (5 / 9)
};

export const Kelvin: ConvertableUnit = {
  label: "K°",
  toStandardUnit: K => K * (9 / 5) - FAHRENHEIT_RANKINE_CONSTANT,
  toThisUnit: F => (F + FAHRENHEIT_RANKINE_CONSTANT) * (5 / 9)
};

export const Rankine: ConvertableUnit = {
  // Legacy Reaver uses +/- 460
  label: "R°",
  toStandardUnit: R => R - FAHRENHEIT_RANKINE_CONSTANT,
  toThisUnit: F => F + FAHRENHEIT_RANKINE_CONSTANT
};

const unitList = [Fahrenheit, Celsius, Kelvin, Rankine];
export const TemperatureUnits = {
  Fahrenheit,
  Celsius,
  Kelvin,
  Rankine,
  options: buildOptions(unitList)
};
